import React, { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../../DesignSystem/Sidebar";
import { subscribeAdviserFullDetailsByEmailOrId } from "../../../../context/Adviser/Utils/AdviserLiveDetails";
import { AdviserListProvider } from "../../../../context/Adviser/Utils/AdviserEmailList";
import { useUserPermissions } from "../../../SignIn/UserPermissionsContext";
import { canAccessDepartmentRoute } from "../../../Departments/utils/departmentConfig";
import { APP_ROUTES } from "../../../../constants/appRoutes";
import EditRates from "./EditRates";
import { storeRatesSaveSuccess } from "./ratesNavigation";

export default function EditRatesPage() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const params = useParams();
  const { userPermissions = [] } = useUserPermissions();
  const canAccessRates = canAccessDepartmentRoute(
    userPermissions,
    APP_ROUTES.IFA_RATES,
  );

  const rawKey =
    params.adviserKey ||
    params.id ||
    params.email ||
    params.adviserId ||
    state?.adviserKey ||
    state?.adviserEmail ||
    "";
  const adviserKey = rawKey ? decodeURIComponent(rawKey) : "";
  const [details, setDetails] = useState(state?.details || null);

  useEffect(() => {
    if (!adviserKey) return undefined;
    return subscribeAdviserFullDetailsByEmailOrId(adviserKey, setDetails);
  }, [adviserKey]);

  const adviserEmail = useMemo(
    () =>
      details?.adviserDoc?.email ||
      details?.email ||
      state?.adviserEmail ||
      adviserKey ||
      "",
    [adviserKey, details, state],
  );

  const adviserName = useMemo(() => {
    const personal = details?.personalDetails || {};
    const fullName = [personal.forename, personal.surname]
      .filter(Boolean)
      .join(" ")
      .trim();
    return fullName || adviserEmail || "Adviser";
  }, [adviserEmail, details]);

  if (!canAccessRates) {
    return <Navigate to="/Department/Finance" replace />;
  }

  return (
    <div className="main-content">
      <Helmet>
        <title>Edit IFA Rates • {adviserName}</title>
      </Helmet>
      <Sidebar />
      <div className="Main-Container">
        <AdviserListProvider>
          <EditRates
            adviserName={adviserName}
            adviserId={details?.adviserId || adviserKey}
            adviserEmail={adviserEmail}
            details={details}
            loading={!details || details.loading}
            onSaved={() => {
              storeRatesSaveSuccess(
                [adviserKey, details?.adviserId, adviserEmail],
                "IFA rate details saved successfully.",
              );
              navigate(
                state?.returnTo ||
                  `/advisers/${encodeURIComponent(adviserKey || adviserEmail)}?tab=rates`,
              );
            }}
          />
        </AdviserListProvider>
      </div>
    </div>
  );
}
